import {useFormContext} from '../../integrations/form/index.js'
import {Button, ButtonProps} from '@chakra-ui/react'

export function SubmitButton(props: Omit<ButtonProps, 'type'>) {
  const form = useFormContext()

  return (
    <form.Subscribe selector={state => state.isSubmitting}>
      {isSubmitting => (
        <Button colorPalette="cyan" disabled={isSubmitting} loading={isSubmitting} {...props} type="submit">
          {props.children}
        </Button>
      )}
    </form.Subscribe>
  )
}
